import axios from "axios";
import {
  APIParser,
  APIParserNoMsg,
  APIDownloadFile,
  AxiosAPIParser,
} from "./api-parser";
import { API_URL, NEW_API_URL } from "./api-client";
import { createFetchGetOptions, getToken } from "./api-util";
import triyoAPI from "./triyo";
const authMvc = window["APP_SETTINGS"].AUTH_MVC;

// GETS
export const GetBlankUserQuery = () => {
  return new Promise((resolve, reject) => {
    resolve({
      pageSize: 10,
      pageNumber: 1,
      sortDesc: false,
      sortBy: "name",
      filters: [],
    });
  });
};

export const UserExistsWithName = (userName) => {
  let searchQuery = {
    pageSize: 100000000,
    pageNumber: 1,
    sortDesc: false,
    sortBy: "name",
    filters: [],
  };

  return GetAllUsersNew(searchQuery).then(
    (result) => {
      return result.Users.find(
        (user) => user.UserName.toLowerCase() == userName.toLowerCase()
      );
    },
    (fail) => {
      console.log("GetAllUsersNew for validating username failed", fail);
    }
  );
};

export const GetAllUsers = (searchQuery) => {
  let searchQueryJSON = JSON.stringify(searchQuery);

  return fetch(API_URL + "getallusers/" + 0, {
    method: "POST",
    body: searchQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetAllUsersNew = (searchQuery) => {
  return triyoAPI
    .post("/users/GetAllUsersWithFilter", searchQuery, config())
    .then((response) => AxiosAPIParser(response));
};

export const GetAllUsersComplete = () => {
  return triyoAPI
    .post(
      "/users/GetAllUsersWithFilter",
      {
        pageSize: 1000000,
        pageNumber: 1,
        sortDesc: false,
        sortBy: "name",
        filters: [],
      },
      config()
    )
    .then((response) => AxiosAPIParser(response));
};

export async function GetEveryUser() {
  const url = NEW_API_URL + "Users/GetEveryUser";
  const response = await fetch(url, createFetchGetOptions());
  return APIParser(response);
}

export const GetUser = (userID) => {
  //deprecate
  let myHeaders = new Headers();
  let token = getToken();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(NEW_API_URL + "user/legacy/currentuser", requestOptions).then(
    (response) => APIParser(response)
  );
};

export const GetUserToken = () => {
  return triyoAPI.get("/user/legacy/token", config());
};

export const DownloadUsers = (token) => {
  return fetch(API_URL + "DownloadUser/" + token + "/1", {
    method: "GET",
    credentials: "include",
  }).then((response) => APIDownloadFile(response));
};

export const DownloadUsersNew = () => {
  return triyoAPI.get("/users/DownloadUsers", config());
};

/*
CREATE
*/
export const CreateUserNew = (user) => {
  return triyoAPI
    .post("/users/CreateUser", user, config())
    .then((response) => AxiosAPIParser(response));
};

export const checkUserEmail = () => {
  return triyoAPI.post("/auth/checkuseremail");
};

export const registerUser = (user) => {
  return triyoAPI.post("/registrations", user);
};

export const setOrganizationTeamSize = (teamSize) => {
  return axios.post(
    window["APP_SETTINGS"].REACT_APP_TEAM_SIZE_API_URL,
    teamSize
  );
};

export const inviteUser = (email) =>
  triyoAPI.post("/user-invitations", { email });

// EDIT USER
export const GetEditUserNew = (userID) => {
  return triyoAPI
    .get("/users/GetUser/" + userID, config())
    .then((response) => AxiosAPIParser(response));
};

export const GetUserForProjectTransfer = (userID) => {
  return triyoAPI
    .get("/users/GetUserForProjectTransfer/" + userID, config())
    .then((response) => AxiosAPIParser(response));
};

export const EditUserNew = (user) => {
  return triyoAPI
    .post("/users/EditUser", user, config())
    .then((response) => AxiosAPIParser(response));
};

export const GetDepartmentAPI = (data) => {
  return triyoAPI.get(
    `/department/GetDepartment?departmentId=${data}`,
    config()
  );
};

export const DeleteUser = (obj) => {
  let userJson = JSON.stringify(obj);

  return fetch(API_URL + "deleteuser/" + 0, {
    method: "POST",
    body: userJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserNoMsg(response));
};

export const DeleteUserNew = (obj) => {
  return triyoAPI.post("/users/DeleteUser", obj, config());
};

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const GetCompanyByUserId = () => {
  return triyoAPI.get("/Users/GetCompanyByUserId/", config());
};

export const GetAllDepartmentsForConfig = () => {
  return triyoAPI.get("/Users/GetAllDepartmentsForConfig/", config());
};

export const ValidateUserEmail = (email, id) => {
  return triyoAPI.get(
    "/users/ValidateUserEmail?email=" + email + "&id=" + id,
    config()
  );
};

export const getAllDepUsers = () => {
  return triyoAPI.get("/users/GetAllUsers", config());
};

export const getProjectWithDep = (id) => {
  return triyoAPI.get("/projects/GetProjectWithDep/" + id, config());
};

export const addMembersToProject = (projectId, memberIds) => {
  return triyoAPI.get(
    "/projects/AddMembersToProject?projectId=" +
      projectId +
      "&userIds=" +
      memberIds,
    config()
  );
};

export const AddMembersAndGroupsToProject = (obj) => {
  return triyoAPI.post("/projects/AddMembersAndGroupsToProject", obj, config());
};
